import axios from "axios";

const instance = axios.create();

const getBearerToken = () => {
  const directToken = localStorage.getItem("userToken");
  if (directToken) {
    return directToken;
  }

  const authStorage = localStorage.getItem("kt-auth-react-v");
  if (!authStorage) {
    return null;
  }

  try {
    const parsedAuth = JSON.parse(authStorage);
    return parsedAuth?.api_token ?? null;
  } catch (error) {
    return null;
  }
};

instance.defaults.headers.post["Content-Type"] = "application/json";
instance.defaults.timeout = 1000 * 30;

// request interceptor
instance.interceptors.request.use(
  (config) => {
    const token = getBearerToken();

    if (!config.headers) {
      config.headers = {};
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete config.headers.Authorization;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// response interceptor
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      window.location.reload();
    }
    return Promise.reject(error);
  },
);

export default instance;
